import React from 'react';
import PropTypes from 'prop-types';

import LazyImage from '../../../../ui-core/Image';
import { Row, Col } from 'react-bootstrap';
import { TEXT_CONSTANT } from '../../../../constants/app';
import { banner, bannerWebp } from '../../images';
import SlashedPrice from '../SlashedPrice';

import './style.css';
import Button from '../../../../ui-core/Button/Button';
import { formatCurrency } from '../../../../utils/helpers';

export const JoinPlan = props => {
  const { isLoading, courseDetail, currentPrice } = props;
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_NOW,
        'isSignup',
        ' Mobility Foundations with Dr. Jen Fraboni, PT, DPT',
      );
    }
  };

  return (
    <div className="mobility-foundations-join-plan" data-aos="fade-in">
      <Row className="mobility-foundations-join-plan-container container">
        <Col
          lg="7"
          xl="8"
          className="d-flex justify-content-center flex-column"
        >
          <h1 className="mf-title">
            <em>Mobility</em> Foundations{' '}
            <small>with Dr. Jen Fraboni, PT, DPT</small>
          </h1>
          <p className="mf-txt">
            Using different methods of mobility to more effectively improve
            joint health, reduce pain & tension and create long term change
            within your body.
          </p>
          <div className="mf-info mb-3">
            <em>Improve</em> joint health <br />
            <em>Reduce</em> pain <br />
            <em>Feel</em> long term change
          </div>
          <div className="mf-price mb-3">
            <SlashedPrice courseDetail={courseDetail} />
          </div>
          <Button
            isDisabled={isLoading}
            isLoading={isLoading}
            class="site-btn-stroke"
            onClick={handleClick}
            text={`Join now at ${formatCurrency(
              currentPrice,
              courseDetail?.attributes?.currency,
              2,
            )}`}
          />
        </Col>
        <Col
          lg="5"
          xl="4"
          className="d-sm-flex align-items-end position-relative"
          data-aos="fade-left"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <div className="mobility-foundations-image-block position-relative">
            <LazyImage
              errorSrc={banner}
              placeholderSrc={bannerWebp}
              src={bannerWebp}
              className="w-100 img-fluid"
            />
            <div className="clr-bg"></div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

JoinPlan.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  courseDetail: PropTypes.object,
  currentPrice: PropTypes.number,
};
